const BASE_PATH = "/ums";
export default class UmsApis {
  constructor(apisClient) {
    this.apis = apisClient;
  }

  async fetchUser() {
    return this.apis.get({
      path: `${BASE_PATH}/user`
    });
  }

  fetchPreferences() {
    return this.apis.get({
      path: `${BASE_PATH}/user/preferences`
    });
  }

  fetchCustomer() {
    return this.apis.get({
      path: `${BASE_PATH}/customer`
    });
  }

  fetchCustomers() {
    return this.apis.get({
      path: `${BASE_PATH}/customers`
    });
  }

  fetchCustomerPrefs() {
    return this.apis.get({
      path: `${BASE_PATH}/customerPrefs`
    });
  }

  fetchCustomerServices() {
    return this.apis.get({
      path: `${BASE_PATH}/customerServices`
    });
  }

  fetchAdvanceConfiguration() {
    return this.apis.get({
      path: `${BASE_PATH}/user/advancedConfiguration`
    });
  }

  fetchShippingSettings() {
    return this.apis.get({
      path: `${BASE_PATH}/user/shippingSettings`
    });
  }

  fetchCustomerAddress() {
    return this.apis.get({
      path: `${BASE_PATH}/user/customerAddress`
    });
  }

  fetchSecuritySettings() {
    return this.apis.get({
      path: `${BASE_PATH}/user/securitySettings`
    });
  }

  async updateUserAppVersion(version) {
    return this.apis.put({
      path: `${BASE_PATH}/user/updateAppVersion`,
      body: {
        dpdLocalAppVersionActual: version
      }
    });
  }

}